var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.definition.results),function(result,name){return _c('div',{key:name},[_c('monitoring-result',{attrs:{"name":name,"values":_vm.values[name] || [],"previous":_vm.previous[name] || []}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }